import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n/config';

const LanguageSwitcher = () => {
  const { i18n: i18nFromHook } = useTranslation();
  
  // Use the imported i18n instance as fallback if hook doesn't provide it
  const i18nInstance = i18nFromHook || i18n;

  const toggleLanguage = () => {
    if (i18nInstance?.changeLanguage) {
      const newLanguage = i18nInstance.language === 'en' ? 'it' : 'en';
      i18nInstance.changeLanguage(newLanguage);
    }
  };

  const currentLang = i18nInstance?.language || 'en';

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-muted transition-colors duration-150 ease-out"
      title={`Switch to ${currentLang === 'en' ? 'Italian' : 'English'}`}
      aria-label="Toggle language"
    >
      <span className="text-lg">
        {currentLang === 'en' ? '🇬🇧' : '🇮🇹'}
      </span>
      {/* <span className="text-lg opacity-50">/</span>
      <span className="text-lg">
        {currentLang === 'en' ? '🇮🇹' : '🇬🇧'}
      </span> */}
    </button>
  );
};

export default LanguageSwitcher;
